import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';

import 'react-dates-17/initialize';
import 'react-dates-17/lib/css/_datepicker.css';
import { SingleDatePicker } from 'react-dates-17';

import ArrowIcon from '../icons/ArrowIcon';
import { DEVICES } from '../../actions/Booking';

const DATE_MASK_PRINT = 'DD/MM/YYYY';

class CalendarSelector extends Component {
  constructor(props) {
    super(props);
    const startDate = moment(props.checkIn);
    const endDate = moment(props.checkOut);
    const activeMonth = moment(startDate).startOf('month');

    this.state = {
      isLoading: true,
      isSearching: false,
      // "dayReloadTrick" is a value which we will ensure changes after each data loading
      // We will use this changing value on the component "Day" elements to force then to be redrawn
      dayReloadTrick: true,
      startDate,
      endDate,
      activeMonth,
      currentMonth: moment().startOf('month'),
      focusedInput: false,
      enabledButton: false,
      minStayNights: 1,
      daysInfo: {},
      showCalendar: false,
    };

    this.onDateChanged = this.onDateChanged.bind(this);
    this.onFocusedInput = this.onFocusedInput.bind(this);
    this.renderDayContents = this.renderDayContents.bind(this);
    this.toggleCalendar = this.toggleCalendar.bind(this);
    this.outsideRangeDays = this.outsideRangeDays.bind(this);
    this.onPrevMonth = this.onPrevMonth.bind(this);
    this.onNextMonth = this.onNextMonth.bind(this);
  }

  formatDate(date) {
    return date.format(DATE_MASK_PRINT);
  }

  outsideRangeDays(day) {
    return day.isAfter(this.state.endDate) || day.isBefore(this.state.startDate);
  }

  toggleCalendar() {
    this.setState((prevState) => ({
      showCalendar: !prevState.showCalendar,
    }));
  }

  onFocusedInput() {
    this.setState((prevState) => ({
      focusedInput: !prevState.focusedInput,
    }));
  }

  onPrevMonth() {
    const activeMonth = moment(this.state.activeMonth).add(-1, 'M');
    this.setState({ activeMonth });
  }

  onNextMonth() {
    const activeMonth = moment(this.state.activeMonth).add(1, 'M');
    this.setState({ activeMonth });
  }

  onDateChanged(date) {
    this.props.onChange(date, this.props.destination, this.props.roundtripSelector);
  }

  renderDayContents(day, mods) {
    const dayKey = this.formatDate(day);
    const dayInfo = this.state.daysInfo[dayKey] || { available: true, stays: 1 };
    const showStays = dayInfo.stays > 1 && !mods.has('blocked');
    return (
      <div className={`stay-day ${dayInfo.available ? '' : 'stay-day--unavailable'}`}>
        {day.format('D')}
        {showStays && <div className="stay-day__min-day">{dayInfo.stays}</div>}
        {dayInfo.amount && <div className="stay-day__price">{dayInfo.amount}</div>}
      </div>
    );
  }

  renderMonthNav(type) {
    const currentMonthCheckin = moment(this.state.startDate).startOf('month');
    const currentMonthCheckOut = moment(this.state.endDate).startOf('month');
    if ((type === 'prev' && currentMonthCheckin.unix() === this.state.activeMonth.unix())
    || (type === 'next' && currentMonthCheckOut.unix() === this.state.activeMonth.unix())) {
      // return <span />;
    }
    return (
      <span className={`arrow arrow--${type}`}>
        <ArrowIcon direction={type === 'next' ? 'left' : 'right'} />
      </span>
    );
  }

  render() {
    return (
      <SingleDatePicker
        id={this.props.idDatePicker}
        date={this.props.dateSelected}
        onDateChange={this.onDateChanged}
        focused={this.state.focusedInput}
        onFocusChange={this.onFocusedInput}
        numberOfMonths={1}
        displayFormat="DD/MM/YYYY"
        showClearDate={false}
        hideKeyboardShortcutsPanel
        readOnly={true}
        isOutsideRange={this.outsideRangeDays}
        navPrev={this.renderMonthNav('prev')}
        navNext={this.renderMonthNav('next')}
        onPrevMonthClick={this.onPrevMonth}
        onNextMonthClick={this.onNextMonth}
      />
    );
  }
}

CalendarSelector.contextTypes = {
  router: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
};

CalendarSelector.propTypes = {
  onChange: PropTypes.func.isRequired,
  dateSelected: PropTypes.object,
  roundtripSelector: PropTypes.string,
  destination: PropTypes.string,
  idDatePicker: PropTypes.string,
  hotelCode: PropTypes.string.isRequired,
};

export default connect((state) => ({
  availMinStay: state.booking.availMinStay,
  hotel: state.booking.hotel,
  checkIn: state.bookingFormState.checkIn,
  checkOut: state.bookingFormState.checkOut,
  isDesktopDevice: state.booking.device === DEVICES.DESKTOP,
  nights: state.booking.last_requested_info.nights,
  isAvailLoading: state.booking.availLoading,
}))(CalendarSelector);
